<template>
  <div id="app" style="margin: 0 auto">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <IconInfo v-if="checkPathVisible()"></IconInfo>
    <FullScreenCompont
      v-if="checkPathFullVisible()"
      :isfull="IsFull"
      :ismobile="isMobile"
      :isandroid="IsAndroid"
      @setFull="setFull"
      @cancelFull="cancelFull"
    ></FullScreenCompont>
    <!-- <el-slider
      class="slider-block"
      :show-tooltip="false"
      v-model="value1"
      vertical
      :max="10"
      :min="1"
      :step="0.1"
      height="200px"
    ></el-slider> -->
  </div>
</template>

<script>
import IconInfo from '@/components/IconInfo/IconInfo'
import FullScreenCompont from '@/components/FullScreenCompont.vue'
import scalseNum from '@/mixins/scalseNum.js'

export default {
  mixins: [scalseNum],
  name: 'App',
  components: { IconInfo, FullScreenCompont },
  data () {
    return {
      value1: 1
    }
  },
  methods: {
    checkPathVisible () {
      let path = [
        // '/',
        '/RDBoard',
        '/finance',
        '/parlor',
        '/digital-marketing',
        '/System-development-division',
        '/kanbanconfig',
        '/quality'
      ]
      return path.includes(this.$route.path)
    },
    checkPathFullVisible () {
      let path = [
        '/CoolSuperScreen',
        '/kanban-config-view',
        '/CoreCompetitiveness',
        '/RDBoard',
        '/',
        '/finance',
        '/parlor',
        '/digital-marketing',
        '/System-development-division',
        '/kanbanconfig',
        '/BSC',
        '/realTimeKanban'
      ]
      return path.includes(this.$route.path) && this.isMobile
    }
  },
  watch: {},
  created () {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const fullMonth = month < 10 ? '0' + month : month
    const curDate = {
      // time: '2021-01',
      time: `${year}-${fullMonth}`,
      isCurMonth: true
    }
    const type = localStorage.getItem('deviceType')
    // if (type === '3') {
    // localStorage.removeItem('token')
    // }
    if (!sessionStorage.getItem('toggleDate')) {
      sessionStorage.setItem('toggleDate', JSON.stringify(curDate))
    }
    this.$store.dispatch('toggleDate', curDate)

    if (process.env.NODE_ENV === 'production') {
      var _hmt = _hmt || []
      ;(function () {
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?f9e8a6ebf5a25165b1a815d801a10dfd'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }
  }
}
</script>

<style scoped lang="stylus"></style>
